import { FullPart, isCustomComponentFull, isOtsComponentFull } from '@luminovo/api-contracts';

export function isComponentRemoved(part: FullPart) {
    if (isOtsComponentFull(part) || isCustomComponentFull(part)) {
        return part.state === 'Removed';
    }
    return false;
}
